import { render, staticRenderFns } from "./categoryAdd.vue?vue&type=template&id=0e6c97a3&"
import script from "./categoryAdd.vue?vue&type=script&lang=js&"
export * from "./categoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports